import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

import type { SearchGroupedResponse } from '@/services/api'
import { searchSymbolsGrouped } from '@/services/api'

const DEBOUNCE_MS = 200
const MIN_QUERY_LEN = 1

export function useSearch(rawQuery: string) {
  const [debouncedQuery, setDebouncedQuery] = useState(rawQuery)

  useEffect(() => {
    const id = setTimeout(() => setDebouncedQuery(rawQuery), DEBOUNCE_MS)
    return () => clearTimeout(id)
  }, [rawQuery])

  const enabled = debouncedQuery.trim().length >= MIN_QUERY_LEN

  const { data, isLoading, isError } = useQuery<SearchGroupedResponse>({
    queryKey: ['search-grouped', debouncedQuery],
    queryFn: () => searchSymbolsGrouped(debouncedQuery.trim()),
    enabled,
    staleTime: 30_000,
    gcTime: 60_000,
    refetchOnWindowFocus: false,
  })

  return {
    results: data?.data ?? {},
    labels: data?.labels ?? {},
    total: data?.meta.total ?? 0,
    isLoading: enabled && isLoading,
    isError,
    query: debouncedQuery,
  }
}
